import { NavigationBar } from '../../features/clips/components/NavigationBar';
import { Styles } from './styles';
import { VideoAndTranscript } from '../../features/clips/components/VideoAndTranscript/VideoAndTranscript';
import { VideoRecapPlayerProvider } from '../../features/shared/contexts/VideoRecapPlayer/VideoRecapPlayerProvider';
import { VideoPlayerProvider } from '../../features/video/contexts/VideoPlayer';
import { useClip } from '../../features/clips/contexts/clip/hook';
import { useVideoPlayer } from '../../features/video/hooks';
import { useEffect } from 'react';
import { Flex, Spin, Typography } from 'antd';
import { UpdateLoader } from '../../componentsV2/UpdateLoader';
import UpdateLogo from '../../components/common/UpdateLogo';
import { useSelector } from 'react-redux';
import { selectUser } from '../../redux/selectors';

const { Container, ContentContainer } = Styles;

export const ClipViewPage = () => {
  const { clip, fetchError, isFetching, addReaction } = useClip();
  const user = useSelector(selectUser);
  const { setReactions, useReaction, setAllowReactions, setShowReactions } = useVideoPlayer();

  useReaction(async reaction => {
    const reactions = await addReaction(reaction.reaction, reaction.timestamp);
    setReactions(reactions);
  });

  useEffect(() => {
    if (user?.id) {
      setAllowReactions(true);
    }
  }, []);

  useEffect(() => {
    if (clip.id) {
      setReactions(clip.reactions);
    }
  }, [clip.id]);

  if (isFetching) {
    return (
      <Container>
        <Flex justify="center" align="center" style={{ width: '100%', height: '100%' }}>
          <UpdateLoader min />
        </Flex>
      </Container>
    );
  }

  if (fetchError) {
    return (
      <Container>
        <Flex
          justify="center"
          align="center"
          vertical
          gap={16}
          style={{ width: '60%', height: '100%', margin: '0 auto' }}
        >
          <UpdateLogo />
          <Typography.Text style={{ textAlign: 'center', fontSize: 16 }}>
            We're unable to locate this clip. Please contact the clip owner to confirm whether they
            have removed it or made it private. If you believe there's an error, you may contact
            support@update.ai and include the clip URL.
          </Typography.Text>
        </Flex>
      </Container>
    );
  }

  return (
    <Container>
      <NavigationBar />
      <ContentContainer>
        <VideoAndTranscript />
      </ContentContainer>
    </Container>
  );
};

export const ClipViewPageProvider = () => {
  return (
    <VideoRecapPlayerProvider>
      <VideoPlayerProvider>
        <ClipViewPage />
      </VideoPlayerProvider>
    </VideoRecapPlayerProvider>
  );
};
